module.exports = __webpack_public_path__ + "static/img/wangxingxing.9dea635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/wangxingxing.png
// module id = +sPK
// module chunks = 0